<!-- 加入我们 -->
<template>

    <div class="aboubox">
        <div @click="istab= false" v-show="istab" class="tabbox nobg">
                <div class="hadtabs">
                    <ul>
                        <li >  <router-link to="/h5home">官网首页</router-link> </li>
                        <li><router-link to="/h5recharge">账户充值</router-link> </li>
                            <li ><router-link to="/h5enlist">主播招募</router-link> </li>
                        <!-- <li ><router-link to="/h5aboutus">关于我们</router-link></li> -->
                        <li  class="active"><router-link to="/h5contactus">联系我们</router-link></li>
                    </ul>
                </div>
            </div>
        <div class="heradbox">
            联系我们  <i @click="istab = true" class="tabicon"></i>
        </div>
        <div class="txtbox">
           <ul class="txtss">
               <li>
                   <p class="title">联系方式 </p>
                   <p class="txt">联系地址：广州市天河区天河科技园 <i class="dicon"></i></p>
                     <p class="txt">联系电话：020-89810547（周一至周五，10:00-18:00）</p>
                       <!-- <p class="txt">客服QQ：800181050 </p> -->
                   <p></p>
               </li>
               <li>
                   <p class="title">微信公众号</p>
                   <p class="txt">微信公众号：nnzb689</p>
                    <p></p>
               </li>
               <li>
                   <p class="title">联系邮箱</p>
                   <p class="txt">合作&意见：kefu@gzxinyuzhou.com</p>
               </li>
               <li>
                   <p class="title">商务合作</p>
                   <p class="txt">公会进驻：nnzb_jiazu</p>
                   <p class="txt">家族进驻：nnzb_gonghui</p>
                   <p class="txt">主播进驻：nnzb_cat</p>
               </li>
               <li>
                   <p class="title">客服帮助</p>
                   <p class="txt">为及时解决您的问题，建议您通过客户端提交意见反馈，我们会尽快在24小时内受理您的问题</p>
                   <p class="txt">1.客服帮助：解封相关事宜或软件使用问题请关注微信公众号“nnzb689”联系在线客服咨询</p>
                   <p class="txt">2.大额充值：请联系微信：nnzb_tu</p>
               </li>
          </ul>  
        </div>
   
         <!-- <Footer></Footer> -->
    </div>  
</template>
<script>
import Footer from "../../components/h5footer"
export default {
     components: {
         Footer
        },
    data(){
        return{
          istab:false,
        }
    },
     created(){

    },
    methods:{

    },
}
</script>
<style lang="less" scoped>
    .aboubox{
        width: 100%; height: 100%; background: #F7F7F7;
    }
    .txtbox{
        width: 90%; margin: .43rem auto 0 auto;background:rgba(255,255,255,1);
            border-radius:0.27rem;
         .txtss{
             padding: .64rem ; box-sizing: border-box;
             li{
                  margin-bottom: 1.04rem;
                  .title{
                     font-weight:600; color:rgba(51,51,51,1);font-size: .43rem;
                      margin-bottom: .37rem;
                  }
                  .txt{
                     color:#999;font-size: .37rem; line-height: .6rem; 
                  }
                  .dicon{
                      background:  url('https://resource.imbeiyu.com/gw/assets/images/h5/icon-location.png');
                      background-size: 100% 100%;
                      width: .35rem; display: inline-block; vertical-align: middle;
                      height: .4rem;
                  }
             }
         }   
    }
    .heradbox{
        width: 100%; height: 1.33rem; background: #fff;position: relative;
        margin-bottom: .22rem;font-size:0.48rem;color: #333333;
        line-height: 1.33rem; text-align: center; font-weight: 500;
            .tabicon{
      background:  url('https://resource.imbeiyu.com/gw/assets/images/h5/icon-more-black.png');
      background-size: 100% 100%;  position: absolute;
      right: .34rem; top: .3rem;  width: .7rem; height:.75rem; 
    }
    }

</style>


// WEBPACK FOOTER //
// src/page/h5page/h5contactus.vue